import React from 'react';
import PropTypes from 'prop-types';
import '@assets/css/common/style_main.css';

const Pagination = ({ 
  currentPage, 
  totalPages, 
  onPageChange,
  pageGroupSize = 5 // 한 번에 보여줄 페이지 번호의 개수
}) => {
  // 현재 페이지 그룹 계산 (0부터 시작)
  const currentGroup = Math.floor((currentPage - 1) / pageGroupSize);
  
  // 현재 그룹의 시작 페이지와 끝 페이지 계산
  const startPage = currentGroup * pageGroupSize + 1;
  const endPage = Math.min(startPage + pageGroupSize - 1, totalPages);
  
  // 페이지 번호 배열 생성
  const pageNumbers = [];
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }
  
  // 이전 그룹으로 이동
  const goToPrevGroup = () => {
    if (currentPage > 1) {
      const prevPage = Math.max(startPage - 1, 1);
      onPageChange(prevPage);
    }
  };
  
  // 다음 그룹으로 이동
  const goToNextGroup = () => {
    if (currentPage < totalPages) {
      const nextPage = Math.min(endPage + 1, totalPages);
      onPageChange(nextPage);
    }
  };
  
  // 처음 페이지로 이동
  const goToFirstPage = () => {
    if (currentPage !== 1) {
      onPageChange(1);
    }
  };
  
  // 마지막 페이지로 이동
  const goToLastPage = () => {
    if (currentPage !== totalPages) {
      onPageChange(totalPages);
    }
  };
  
  // 페이지가 한 개 이하인 경우 페이지네이션 표시하지 않음
  if (totalPages <= 1) {
    return null;
  }
  
  return (
    <div className="pagination">
      {/* 첫 페이지로 이동 버튼 (시작 페이지가 1이 아닐 때만 표시) */}
      {startPage > 1 && (
        <a 
          href="#" 
          className="page-nav"
          onClick={(e) => {
            e.preventDefault();
            goToFirstPage();
          }}
        >
          <i className="ri-arrow-left-double-line"></i>
        </a>
      )}
      
      {/* 이전 그룹으로 이동 버튼 */}
      <a 
        href="#" 
        className={`page-nav ${currentPage === 1 ? 'disabled' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          goToPrevGroup();
        }}
      >
        <i className="ri-arrow-left-s-line"></i>
      </a>
      
      {/* 페이지 번호 */}
      {pageNumbers.map(number => (
        <a
          key={number}
          href="#"
          className={`page-number ${number === currentPage ? 'active' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            onPageChange(number);
          }}
        >
          {number}
        </a>
      ))}
      
      {/* 다음 그룹으로 이동 버튼 */}
      <a 
        href="#" 
        className={`page-nav ${currentPage === totalPages ? 'disabled' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          goToNextGroup();
        }}
      >
        <i className="ri-arrow-right-s-line"></i>
      </a>
      
      {/* 마지막 페이지로 이동 버튼 (끝 페이지가 totalPages가 아닐 때만 표시) */}
      {endPage < totalPages && (
        <a 
          href="#" 
          className="page-nav"
          onClick={(e) => {
            e.preventDefault();
            goToLastPage();
          }}
        >
          <i className="ri-arrow-right-double-line"></i>
        </a>
      )}
    </div>
  );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  pageGroupSize: PropTypes.number
};

export default Pagination;